"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.iconStyles = void 0;
var tslib_1 = require("tslib");
var emotion_1 = require("emotion");
var iconStyles = function () { return (0, emotion_1.css)(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n  height: 1em;\n"], ["\n  height: 1em;\n"]))); };
exports.iconStyles = iconStyles;
var templateObject_1;
